module.exports = __webpack_public_path__ + "media/images/pages/img_access_01-c70d960b96c554528b49cf249d779e2d.jpg";